import React from 'react';

import { css, cx } from '@emotion/css';
import { Form, FormItemProps, Switch } from 'antd';

export interface SwitchFormItemProps extends FormItemProps {
  onChange: (value: boolean) => void;
}

export function SwitchFormItem({ label, name, onChange, ...props }: SwitchFormItemProps) {
  return (
    <>
      <Form.Item
        noStyle
        name={name}
        label={label}
        valuePropName="checked"
        className={cx(
          css`
            display: flex;
            align-items: center;

            // Override internal default stylying to place label on the same row as the switch
            & .ant-form-item-control-input-content {
              display: flex !important;
              flex-direction: row !important;
              align-items: center;
            }
          `,
          props.className,
        )}
        {...props}
      >
        <Switch
          className={css`
            margin-right: 8px;
          `}
          onChange={onChange}
        />
      </Form.Item>
      {label}
    </>
  );
}
